export default __webpack_public_path__ + "static/img_1-f38b711e4ba9aa559eda06c2cb12cd83.png";